import {Button, ButtonGroup, Choice, closeDialog} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useState} from 'react';

import {useGetHandlingUnitsQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {getOptionsFromHandlingUnits} from '@dms/shared-aftersales';

import {pushGtmEvent} from 'shared/web';

interface ChangeUnitProps {
  dialogId: string;
  onAssign: (unitId: string) => void;
}

export function ChangeUnit(props: ChangeUnitProps) {
  const [unitId, setUnitId] = useState<string | null>(null);

  const handlingUnitsQuery = useGetHandlingUnitsQuery();

  const defaultUnitId = handlingUnitsQuery.data?.find((unit) => unit.isDefault)?.id ?? null;
  const selectedUnitId = unitId ?? defaultUnitId;

  const handleDiscard = () => {
    pushGtmEvent({event: 'button_click', event_id: 'ai_tool_dn_change_unit_discard'});
    closeDialog(props.dialogId);
  };

  const handleAssign = () => {
    if (!selectedUnitId) {
      return;
    }
    pushGtmEvent({event: 'button_click', event_id: 'ai_tool_dn_change_unit'});
    props.onAssign(selectedUnitId);
    closeDialog(props.dialogId);
  };

  return (
    <VStack spacing={4}>
      <Choice
        isRequired
        isLoading={handlingUnitsQuery.isLoading}
        isNotClearable
        value={selectedUnitId}
        onChange={setUnitId}
        options={getOptionsFromHandlingUnits(handlingUnitsQuery.data)}
        label={i18n.t('entity.warehouse.labels.unit')}
        menuInPortal
      />
      <ButtonGroup align="right">
        <Button
          title={i18n.t('general.actions.discard')}
          variant="secondary"
          onClick={handleDiscard}
        />
        <Button
          isDisabled={!selectedUnitId}
          title={i18n.t('general.actions.assign')}
          variant="primary"
          onClick={handleAssign}
        />
      </ButtonGroup>
    </VStack>
  );
}
